import initSentry from 'sentry/initSentry'

initSentry()
